import { colors } from 'muiTheme/palette';

export const CHART_AXIS_PROPS = {
  strokeWidth: 1,
  fontSize: 13,
  stroke: colors.darkGrey,
  fontFamily: 'Domine',
};
